import { axios } from '@/utils/request'


const api = {
  orderDetail: '/badminapi/shopOrder/orderdetail',
  fenxiaoOrderDetail: '/badminapi/shopOrder/fenxiaoorderdetail',

  orderConfirm: '/badminapi/shopOrder/orderConfirm',
  orderUse: '/badminapi/shopOrder/orderToUse',
}
export default api
export function getOrderDetail(parameter) {
  return axios({
    url: api.orderDetail,
    method: 'get',
    params: parameter
  })
}
export function getFenxiaoOrderDetail(parameter) {
  return axios({
    url: api.fenxiaoOrderDetail,
    method: 'get',
    params: parameter
  })
}
export function orderConfirm(parameter) {
  return axios({
    url: api.orderConfirm,
    method: 'post',
    data: parameter
  })
}
export function orderUse(parameter) {
  return axios({
    url: api.orderUse,
    method: 'post',
    data: parameter
  })
}